module.exports = __webpack_public_path__ + "static/hero-construction-ind-c8896fbe4453f1ee732098da4ebf0479.png";